import React, { useEffect, useState } from "react";
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import StandingItem from "./Components/StandingItem";
import { getFlowerPackage } from "../../../redux/action/flower-package";
import { Home_Standing } from "../../../utils/formatType";


function StandingPage() {
  const { flowerPackageDetail } = useSelector((state) => state.flowerPackage);
  console.log("flowerPackageDetail", flowerPackageDetail);
  

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await dispatch(getFlowerPackage(Home_Standing));
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []); // chỉ chạy lần đầu

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <TitleComponent
            title="Nổi bật"
            type="primary"
            
          />
          {flowerPackageDetail && flowerPackageDetail.flowers != null && flowerPackageDetail.flowers.length > 0 ? (
            <StandingItem flower={flowerPackageDetail.flowers} />
          ) : (
            <p>Không có hoa nào trong gói này.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default StandingPage;
